'use client';

import { usePathname } from 'next/navigation';
import { useFeatureFlag } from '@/app/hooks/useFeatureFlag';
import { guideChatKindForPath } from '@/app/lib/guideChat/triggers';
import GuideChatWidget from './GuideChatWidget';

// Off until switched on in GrowthBook: the widget needs the guide-chat backend and its indexed corpus to answer.
export const GUIDE_CHAT_FEATURE_FLAG = 'guide_chat';

// §2.2: the assistant only lives on the loan-insurance guide, landing and comparator pages.
export default function GuideChatMount() {
  const pathname = usePathname() ?? '';
  const enabled = useFeatureFlag(GUIDE_CHAT_FEATURE_FLAG);
  const kind = guideChatKindForPath(pathname);
  if (!enabled || !kind) return null;
  return <GuideChatWidget key={pathname} kind={kind} />;
}
